export default "__VITE_ASSET__BOXJgCoq__"